// src/components/Footer.jsx
import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, ExternalLink } from "lucide-react";
import { ROUTES } from "../config/routes";

const Footer = () => {
  const quickLinks = [
    { name: "Home", path: ROUTES.HOME },
    { name: "About", path: ROUTES.ABOUT },
    { name: "Dignitaries", path: ROUTES.DIGNITARIES },
    { name: "Committee", path: ROUTES.COMMITTEE },
    { name: "Schedule", path: ROUTES.SCHEDULE },
    { name: "Registration", path: ROUTES.REGISTRATION },
    { name: "Sponsorship", path: ROUTES.SPONSORSHIP },
    { name: "Contact", path: ROUTES.CONTACT },
    { name: "Gallery", path: ROUTES.GALLERY },
  ];

  return (
    <footer className="bg-gradient-to-br from-blue-950 to-blue-950 text-gray-200 pt-12 pb-6 mt-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          <div className="lg:col-span-2">
            <h3 className="text-white text-xl sm:text-2xl font-bold mb-4">
              TG-SMART 2026
            </h3>
            <p className="text-gray-300 leading-relaxed mb-2 text-sm sm:text-base">
              International Conference on Transportation Geotechnics &
              Sustainable Materials for Advanced Resilient Infrastructure
            </p>
            <p className="text-blue-400 font-bold text-base sm:text-lg mt-4">
              October 8-10, 2026
            </p>
            <p className="text-white text-sm mt-2">
              Integral University, Lucknow, India
            </p>
          </div>

          {/* Quick Links now centralized */}
          <div>
            <h4 className="text-white text-lg sm:text-xl font-bold mb-4">
              Quick Links
            </h4>
            <ul className="space-y-2">
              {quickLinks.map((item) => (
                <li key={item.name}>
                  <Link
                    to={item.path}
                    className="text-gray-300 hover:text-blue-400 hover:pl-2 transition-all duration-200 inline-block text-sm sm:text-base"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact stays same */}
          <div>
            <h4 className="text-white text-lg sm:text-xl font-bold mb-4">
              Contact Us
            </h4>
            <div className="space-y-3">
              <div className="flex items-start gap-3">
                <Mail size={18} className="text-blue-400 mt-1" />
                <a
                  href="mailto:tgsmart2026@iul.ac.in"
                  className="text-gray-300 text-sm sm:text-base"
                >
                  tgsmart2026@iul.ac.in
                </a>
              </div>

              <div className="flex items-start gap-3">
                <Phone size={18} className="text-blue-400 mt-1" />
                <span className="text-gray-300 text-sm sm:text-base">
                  +91-8707870833, +91-9415985237, +91-9026074042
                </span>
              </div>

              <div className="flex items-start gap-3">
                <MapPin size={18} className="text-blue-400 mt-1" />
                <span className="text-gray-300 text-sm sm:text-base">
                  Integral University, Lucknow
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t pt-6 text-center">
          <p className="text-gray-300 text-xs sm:text-sm">
            &copy; 2026 TG-SMART Conference. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
